"use strict";

import barba from "@barba/core";


(function() {
	if (history.scrollRestoration) {
  	history.scrollRestoration = 'manual';
	}
	
	
	barba.init({
		//debug: true,
		
		prevent: ({ el }) => el.closest('#moka--backendbar') !== null,
		
		
		transitions: [{
			name: 'fade',
			leave: (data) => {
				// create your stunning leave animation here
				return gsap.to(data.current.container, {
					opacity: 0,
					duration: .5,
				});
			},
			enter: (data) => {
				// create your amazing enter animation here
				return gsap.from(data.next.container, {
					opacity: 0,
					duration: .25,
				});
			},
		}],
		
		views: [{
			namespace: 'main',
			beforeEnter() {
				// update the menu based on user navigation
				//menu.update();
				window.scrollTo(0,0);
			},
			
			afterEnter( data ) {
				const domId = 'css-theme-colors';
				const parser = new DOMParser();
				const html = parser.parseFromString(data.next.html, 'text/html');
				const styleTag = html.getElementById(domId);
				const node = document.getElementById(domId);
				if( node ) {
					node.textContent = styleTag.textContent;
				}
				else {
					document.head.appendChild(styleTag);
				}
			},
		}],
	});
	
	
	barba.hooks.before(() => {
		const evt = new CustomEvent('pageLeave', {
			detail:{ document: document }, 
		});
		document.dispatchEvent(evt);
	});
	
	
	barba.hooks.after(() => {
		const evt = new CustomEvent('pageLoad', {
			detail:{ document: document }, 
		});
		document.dispatchEvent(evt);
	});
	
	
	const links = Array.from( document.querySelectorAll('.app-primary-nav .primary-nav a') );
	links.forEach(l => {
		l.addEventListener('click', () => {
			const evt = new CustomEvent('navPanelClose');
			document.dispatchEvent(evt);
		});
	});
})();